import {pageInfo, initPage,orderMivImport, exportData} from './../api';
import { Message } from 'element-ui';
import {upoladImg, upoladZip} from "../../toBUpdate/statusUpdate/api";
const factory = {
  namespaced: true,
  state: {
    total:0,
    resp:null,
    pageResp:null,
    initPageObj: null,
    initUpdateObj: null,
    deleteFactory:null,
    exportObj:null,
    factoryResp:null,
    templateObj:null,
    uploadUrlData: upoladZip,
    orderMivImportObj:null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    GET_DELETE_FACTORY(state,data){
      state.deleteFactory = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.factoryResp = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    ORDER_MIV_IMPORT(state, resp){
      state.orderMivImportObj = resp || [];
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    async getDeleteFactory({commit}, obj){
      let resp = await getDeleteFactory(obj);
      commit('GET_DELETE_FACTORY', resp);
    },
    //导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },    //导入数据
    async factoryUpLoad({ commit }, obj) {
      let resp = await updateFactoryUpload(obj);
      commit('UPLOAD_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    async orderMivImport({ commit }, obj){
      let resp = await orderMivImport(obj);
      commit('ORDER_MIV_IMPORT', resp);
    }
  }
}
export default factory



// WEBPACK FOOTER //
// ./src/page/orderMiv/store/orderMiv.store.js